<template>
    <transition name="modal-fade" v-if="isVisible">
        <div class="modal-overlay">
            <div class="modal-content hide-scrollbar" @click.stop >
                <div style="text-align:right; margin:8px -16px -40px 0; z-index:999;"><span class="material-icons" @click="$emit('close-modal')">close</span></div>
                
                    <div class="col-12 title">{{title}}</div>
                     
                   
                    <div v-for="project in paginatedProjects()" :key="project.Id" 
                    @click="goToProject()"
                    class="box" style="display:flex; width:100%; padding: 4px 8px; align-items:center; opacity: 0.8;" 
                    :style="project.Status === 0 
                        ? 'background: #bbffdf;' 
                        : project.Status === 1 
                            ? 'background: #198754;' 
                            : 'background: #fff8d3;'">
                        <div style="flex:1">
                            <div v-if="project.Contracts && project.Contracts.length > 0" class="bold" style="font-size: 14px;">
                                    {{ project.Contracts[0].CommencementDate }}  - {{project.Name}}
                            </div>
                            <div v-else class="bold">{{project.Name}}</div>
                            <div class="info">                           
                                {{project.Address}} {{project.City}}, {{project.Province}} {{project.PostalCode}}
                            </div>
                        </div>
                        <div>
                            <i class="material-icons" style="font-size: 24px;">chevron_right</i>
                        </div>
                        
                    </div>
 
                    <div class="row" style="display:flex; justify-content:center; flex:1; margin-top: 16px; margin-bottom: 16px;">
                        <n-pagination v-model:page="projectsPage" :page-count="projectsPageCount" style="width:fit-content; height:fit-content;align-self:end;" />
                    </div>
            </div>
            
        </div>
    </transition>

</template>

<script>
import { t } from '@wangeditor/editor';
import { type } from 'jquery';

    export default {

        props: {
            visible: Boolean,
            List: Object,
            Type: String,
            UserId: String
        },

        data() {
            return {
                Projects:  [],
                title: "Project Summary",
                isVisible: this.visible, // Local visibility state
                list: [],
                type: '',
                userId: '',
                pageSize: 5,
                projectsPage: 1,
                projectsPageCount: 1,
            }
        },
        mounted() {

            console.log("List", this.list);
        },
        watch: {
            visible(newVal) {
                this.isVisible = newVal; // Sync local state with prop changes
                this.list = this.List;
                this.type = this.Type;
                this.userId = this.UserId;
                

                if(newVal) {
                    this.getProjects();
                    this.projectsPage = 1;
                }
                //console.log("List", this.list);
                
            },
        },
        methods: {

            paginatedProjects() {

                if (this.Projects == null) {
                    return [];
                }


                // Update pageCount based on filtered results and pageSize
                this.projectsPageCount = Math.ceil(this.Projects.length / this.pageSize);

                // Return the paginated results for the current page
                const start = (this.projectsPage - 1) * this.pageSize;
                const end = start + this.pageSize;
                console.log("paginatedProjects", this.Projects.slice(start, end));
                return this.Projects.slice(start, end);
            },
            getProjects() {
                this.Projects = [];
                console.log("getProjects", this.list, this.userId);

                let list = this.list.find(item => item.Id == this.userId);
                
                for (let i = 0; i < list.Projects.length; i++) {
                    if(list.Projects[i].Contracts.length > 0){   
                        for(let j = 0; j < list.Projects[i].Contracts.length; j++) {
                            let tempProject = JSON.parse(JSON.stringify(list.Projects[i]));
                            tempProject.Contracts = [list.Projects[i].Contracts[j]];
                            this.Projects.push(tempProject);
                        }                        
                    } else {
                        this.Projects.push(list.Projects[i]);
                    }
                }

                //this.Projects = list.Projects;

                console.log("getProjects", this.Projects);

            },
            goToProject() {
                this.$emit('goToProject');
            }

        }
    }
</script>

<style scoped>

    .box{
        border: 1px solid #ccc;
        border-radius: 8px;
        margin-bottom: 8px;
        padding: 8px;
        position: relative;
        background: #f1f2f6;
    }
    .modal-overlay {
        z-index:999;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #000000da;
        max-width:100%;
    }

    .modal-content {
        background-color: white;
        height: fit-content;
        width: 500px;
        max-width: 90vh;
        max-height: 90vh;
        margin:auto;
        padding: 0px 24px;
        border-radius: 20px;
       
    }


   

    .check {
        width: 150px;
    }

   
    p {
        /* font-weight: 500; */
        font-size: 16px;
        margin: 20px 0;
    }

    button {
        background-color: #ac003e;
        width: 150px;
        height: 40px;
        color: white;
        font-size: 14px;
        border-radius: 16px;
        margin-top: 50px;
    }

    .modal-fade-enter,
    .modal-fade-leave-to {
        opacity: 0;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity 0.5s ease;
    }

    .form-check-inline {
        margin: 4px 0px;
    }

    .form-check-label {
        vertical-align: middle;
    }

    .form-check-input {
        vertical-align: middle;
    }

    .title{padding: 16px 0; font-weight: bold;}
</style>